import {useTranslation} from "react-i18next";


import AboutTabs from "./AboutTabs/AboutTabs";

const About = () => {
    const {t} = useTranslation();
    let title = t('about.title'),
        description = t('about.description');

    return (
        <div className="about-area pt--120  bg_color--1" id="about">
          <div className="about-wrapper">
            <div className="container">
              <div className="row row--35">
                <div className="col-lg-5">
                  <div className="thumbnail">
                    <img className="w-100" src="/assets/images/about/about.jpg" alt="About Images"/>
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="about-inner inner">
                    <div className="section-title">
                      <h2 className="title">{title}</h2>
                      <p className="description">{description}</p>
                    </div>
                    <div className="row mt--30">
                      <AboutTabs/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
}

export default About;
